module.exports = __webpack_public_path__ + "img/home_risk.8b197035.jpg";